import { render, staticRenderFns } from "./Industryinformation.vue?vue&type=template&id=0556804f&"
import script from "./Industryinformation.vue?vue&type=script&lang=js&"
export * from "./Industryinformation.vue?vue&type=script&lang=js&"
import style0 from "./Industryinformation.vue?vue&type=style&index=0&id=0556804f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports